import React from "react";
import PropTypes from "prop-types";
import { SkeletonLoadingComponent } from "../../../../../parts/SkeletonLoadingComponent";

export const CommunityChatUnmounted = ({ webAppTheme }) => {
  return (
    <>
      <div className={`unmounted-chats-list chats-list-container`}>
        <SkeletonLoadingComponent
          uniqueKey="community-chat-list"
          webAppTheme={webAppTheme}
          title="community chat list"
          style={{ height: "85vh" }}
          content={
            <>
              <rect x="0" y="25" rx="4" ry="4" width="100%" height="15%" />
              <rect x="0" y="115" rx="5" ry="5" width="100%" height="100%" />
            </>
          }
        />
      </div>
      <div
        className={
          webAppTheme == "dark"
            ? `dark-conversation-container conversation-container`
            : `light-conversation-container conversation-container`
        }
      >
        <div
          className={
            "unmounted-chats-list chat-box chat-box-mobile-chat-opened"
          }
        >
          <SkeletonLoadingComponent
            uniqueKey="community-chat-box"
            webAppTheme={webAppTheme}
            title="community chat box"
            style={{ height: "85vh", width: "90%" }}
            content={
              <>
                <rect x="0" y="105" rx="5" ry="5" width="100%" height="100%" />
              </>
            }
          />
        </div>
      </div>
    </>
  );
};

CommunityChatUnmounted.propTypes = {
  webAppTheme: PropTypes.string,
};
